import { defineMessages } from 'react-intl';

import { addStyling } from '@plone/volto/helpers/Extensions/withBlockSchemaEnhancer';
import fullSVG from '@plone/volto/icons/image-full.svg';

import mediumSVG from '../theme/icons/med_width_icon.svg';
import smallSVG from '../theme/icons/small_width_icon.svg';

const messages = defineMessages({
  full: {
    id: 'Full width',
    defaultMessage: 'Full width',
  },
  medium: {
    id: 'Medium width',
    defaultMessage: 'Medium width',
  },
  small: {
    id: 'Small width',
    defaultMessage: 'Small width',
  },
  containerWidth: {
    id: 'Container width',
    defaultMessage: 'Container width',
  },
});

export const containerStyleSchema = ({ schema, formData, intl }) => {
  addStyling({ schema, intl });
  schema.properties.styles.schema.fieldsets[0].fields = [
    ...schema.properties.styles.schema.fieldsets[0].fields,
    '--layout-container-width',
  ];

  schema.properties.styles.schema.properties['--layout-container-width'] = {
    title: intl.formatMessage(messages.containerWidth),
    widget: 'buttons',
    default: '1440px',
    actionsInfoMap: {
      '1440px': [fullSVG, intl.formatMessage(messages.full)],
      '936px': [mediumSVG, intl.formatMessage(messages.medium)],
      '702px': [smallSVG, intl.formatMessage(messages.small)],
    },
  };
  schema.properties.styles.schema.properties[
    '--layout-container-width'
  ].actions = ['1440px', '936px', '702px'];

  return schema;
};
